export default __webpack_public_path__ + "static/media/MastercardPure.7f8ac9ca.svg";